"use client";

import { colors, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import MediaV2 from "@v2/components/MediaV2";
import useTouchable from "@v2/hooks/useTouchable";
import dayjs from '@v2/lib/dayjs';
import Link from "next/link";
import { useMemo } from "react";

type BlogType = {
    id: number,
    slug: string
    title: string
    image_id: string | null
    image_alt: string | null
    post_date: string
    show_in_site: boolean,
    post_modified: string
};
type BlogsContentType = BlogType[];
export default function LatestNews({
    content
}: {
    content: BlogsContentType
}) {
    const theme = useTheme()
    const isTouchable = useTouchable()

    const calcFromNow = useMemo(() => (datetime: string) => {
        return dayjs(datetime, 'YYYY-MM-DD HH:mm:ss').locale('fa').fromNow();
    }, [])

    return (
        <Grid
            container
            size={{ md: 10.5, xs: 12 }}
            spacing={{ md: 4, xs: 5 }}
            sx={{ px: { xs: 3, lg2: 0, } }}
        >
            <Grid size={{ xs: 12 }}>
                <Typography
                    component="h2"
                    sx={{
                        fontSize: { xs: 22, md: 28 },
                        
                        fontWeight: 700,
                        color: colors.grey[900],
                        textAlign: { md: "left", xs: "center" },
                        [theme.breakpoints.down('md')]: {
                            fontSize: 28
                        },
                    }}
                >
                    آخرین دانستنی ها
                </Typography>
            </Grid>
            {content?.map((blog) => (
                <Grid key={blog.id} size={{ md: 4, xs: 12 }} component="article">
                    <Box component={Link} href={"/fa/blog/" + blog.slug}
                        sx={{
                            display: 'block',
                            borderRadius: 1,
                            transition: '200ms',
                            overflow: 'hidden',
                            ...(isTouchable ? {
                                boxShadow: "rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;"
                            } : {
                                '&:hover': {
                                    transform: 'translateY(-3px)',
                                    boxShadow: "rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;"
                                }
                            })
                        }}>
                        <Box
                            sx={{
                                position: "relative",
                                width: "100%",
                            }}
                        >
                            {/* <Media id={blog.image_id} alt={blog.image_alt ?? ""} aspectRatio="16 / 9" sx={{ borderRadius: '8px 8px 0 0', overflow: 'hidden' }} /> */}
                            <MediaV2
                                media_id={blog.image_id}
                                alt={blog.image_alt || blog.title}
                                withLoading
                                boxProps={{
                                    sx: {
                                        width: '100%',
                                        aspectRatio: "16 / 9",
                                    }
                                }}
                                options={{

                                }}
                                height={260}
                                imageProps={{
                                    fill: true,
                                    style: {
                                        objectFit: 'cover',
                                    }
                                }}
                            />
                        </Box>
                        <Box sx={{ p: 2, pt: 0 }}>
                            <Typography
                                component="h3"
                                sx={{
                                    fontSize: 16,
                                    fontWeight: 700,
                                    color: "#000000DE",
                                    mt: 2,
                                    minHeight: 48,
                                }}
                            >
                                {blog.title}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: 14,
                                    fontWeight: 400,
                                    color: "#00000099",
                                    mt: 1,
                                }}
                            >
                                {calcFromNow(blog.post_date)}
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            ))}
            <Grid size={{ xs: 12 }}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Button
                        component={Link}
                        variant="contained"
                        // disableElevation
                        sx={{ width: 121, height: 48 }}
                        href={'/fa/blog/'}
                    >
                        مطالب بیشتر
                    </Button>
                </Box>
            </Grid>
        </Grid>
    );
}
